export var NodeType = /*#__PURE__*/ function(NodeType) {
    NodeType["gem"] = "gem";
    NodeType["simpleGemNode"] = "simpleGemNode";
    NodeType["tile"] = "tile";
    NodeType["subFlow"] = "subFlow";
    NodeType["simpleSubFlow"] = "simpleSubFlow";
    NodeType["comment"] = "comment";
    NodeType["ERDNode"] = "ERDNode";
    return NodeType;
}({});
export var LayoutAlgo = /*#__PURE__*/ function(LayoutAlgo) {
    LayoutAlgo["elk"] = "Layer Based Layout";
    LayoutAlgo["dagre"] = "Simple DAG Layout";
    return LayoutAlgo;
}({});
export var NodeStateTypes = /*#__PURE__*/ function(NodeStateTypes) {
    NodeStateTypes["default"] = "default";
    NodeStateTypes["loading"] = "loading";
    NodeStateTypes["success"] = "success";
    NodeStateTypes["error"] = "error";
    NodeStateTypes["zap"] = "zap";
    NodeStateTypes["warning"] = "warning";
    NodeStateTypes["skipped"] = "skipped";
    return NodeStateTypes;
}({});
